let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("clhk4")).then(() => parcelRequire('hZouV'));